<template>
  <div class="bottom-content">
    <a-button type="primary" :disabled="proSource!=0" @click="proPublish" :loading="submitLoading">发布并上架</a-button>
  </div>
</template>

<script>
export default {
  name: 'PublishPro',
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      isMType: this.$route.query.isMType,
      submitLoading: false
    }
  },
  mounted() {
  },
  methods: {
    //产品发布
    proPublish() {
      this.submitLoading = true
      this.getHttpServices().getProService().post('public/proRelease/' + this.proId).then(res => {
        this.getLogUtils().logWithTag('proPublish', res)
        this.$message.success('产品发布成功')
        this.clearH5Cache()//清除H5页面相关缓存
        this.goToSucceedPage()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    goToSucceedPage() { // 是否是跨境商品
      this.$router.push({
        name: 'SucceedPage',
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource,
          isMType: this.isMType
        }
      })
    }
  }

}
</script>
<style lang="less" scoped>
.bottom-content {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #FFF;
  margin-top: 20px;
  box-sizing: border-box;
  padding-left: 20px;
}
</style>